import axios from "axios";
import React, { useState, useEffect, useRef } from "react";
import { IoIosCall } from "react-icons/io";
import { IoLocationOutline } from "react-icons/io5";
import { Link } from "react-router-dom";
import { BASE_URL } from "../../../constant/api";
import { IoLogoWhatsapp } from "react-icons/io";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function SearchNavsmall() {
    const [searchResult, setSearchResult] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedIndex, setSelectedIndex] = useState(null);
    const searchResultRef = useRef([]);
    const listRef = useRef(null);

    useEffect(() => {
        if (searchQuery.length > 0) {
            fetchSearchResults(searchQuery);
        } else {
            setSearchResult([]);
        }
    }, [searchQuery]);

    const fetchSearchResults = async (query) => {
        try {
            const response = await axios.post(`${BASE_URL}/products/search/`, {
                search_word: query,
            });
            if (response.status === 200 && response.data.Status === "1" && response.data.Data.length > 0) {
                setSearchResult(response.data.Data);
            } else {
                setSearchResult([]);
            }
        } catch (error) {
            console.log("Error fetching search results:", error);
            setSearchResult([]);
        }
    };

    // Function to handle keydown for arrow keys and Enter key
    const handleKeyDown = (e) => {
        if (searchQuery.trim() !== "") {
            if (e.key === "Enter") {
                window.location.href = `/search?query=${encodeURIComponent(searchQuery.trim())}`;
            }
            return;
        }
        if (e.key === "Enter" && selectedIndex !== null) {
            window.location.href = `/product-details/${searchResult[selectedIndex].id}`;
        }
    };

    // Function to scroll the selected item into view
    const scrollToItem = (index) => {
        const selectedItem = searchResultRef.current[index];
        if (selectedItem) {
            selectedItem.scrollIntoView({
                behavior: "smooth",
                block: "center",
            });
        }
    };

    const handleWhatsAppClick = () => {
        const phoneNumber = "+919656033444";
        const message = "hi, i need a help";
        const encodedMessage = encodeURIComponent(message);
        const url = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
        window.open(url, "_blank");
    };

    const handlePhoneCall = () => {
        const phoneNumber = "+919656033444";
        if (/Mobi|Android/i.test(navigator.userAgent)) {
            window.location.href = `tel:${phoneNumber}`;
        } else {
            navigator.clipboard.writeText(phoneNumber)
                .then(() => {
                    toast.success(`Phone number copied: ${phoneNumber}`, {
                        position: "top-center",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                    });
                })
                .catch((err) => {
                    toast.error("Failed to copy phone number", {
                        position: "top-center",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                    });
                    console.error("Failed to copy phone number: ", err);
                });
        }
    };

    return (
        <div className="relative w-full border-t-2" onKeyDown={handleKeyDown} tabIndex="0">
            <ToastContainer position="top-center" autoClose={3000} />
            <div className="flex w-full max-w-full items-center justify-between rounded-b-lg bg-white border-2 border-solid p-3 md:ms-3 md:w-1/2">
                <div className="flex flex-grow items-center">
                    <div className="relative flex-grow">
                        <input
                            type="text"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            placeholder="Search"
                            className="w-full rounded-e-md border border-gray-300 py-2 pl-4 focus:outline-none"
                        />
                    </div>
                </div>
                <div className="flex flex-row gap-5 mx-5">
                    <div className="flex items-center cursor-pointer" onClick={handlePhoneCall}>
                        <IoIosCall className="text-3xl text-gray-600" />
                    </div>
                    <div className="flex items-center cursor-pointer" onClick={handleWhatsAppClick}>
                        <IoLogoWhatsapp className="text-3xl text-green-500" />
                    </div>
                </div>
            </div>

            {searchResult.length > 0 && (
                <div
                    className="absolute top-full left-0 w-full md:w-1/2 mt-2 bg-white border border-gray-300 rounded-md shadow-lg max-h-96 overflow-y-auto z-50 md:ms-10"
                    ref={listRef}
                >
                    <ul className="p-2 space-y-4">
                        {searchResult.map((product, index) => (
                            <li
                                key={product.id}
                                className={`flex items-center hover:bg-gray-100 ease-in duration-200 transition border-b p-2 ${selectedIndex === index ? "bg-gray-100" : ""}`}
                                ref={(el) => (searchResultRef.current[index] = el)}
                            >
                                <Link
                                    to={`/product-details/${product.id}`}
                                    className="flex w-full"
                                    onClick={() => setSelectedIndex(index)}
                                >
                                    <img
                                        src={
                                            product.product_images?.[0]?.image
                                                ? product.product_images[0].image.startsWith(BASE_URL)
                                                    ? product.product_images[0].image
                                                    : `${BASE_URL}${product.product_images[0].image}`
                                                : "/images/default-product.png"
                                        }
                                        alt={product.name}
                                        className="w-16 h-16 object-cover rounded mr-4"
                                    />
                                    <div>
                                        <h3 className="font-semibold">{product.name}</h3>
                                        <p className="text-gray-500">
                                            <span className="line-through text-sm mr-2">${product.actual_price}</span>
                                            <span className="font-bold">${product.price}</span>
                                            <span className="text-green-600 ml-2">({product.offer_percent}% OFF)</span>
                                        </p>
                                        <p className="text-sm text-gray-600 line-clamp-3">{product.description}</p>
                                    </div>
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
}

export default SearchNavsmall;
